import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MediaSlotView } from "../render/context";
import { resolveSlotMedia } from "../render/slot-media";
import { Section } from "./_section";
/**
 * PlaygroundVideoBlock — test-only band whose single slot takes a picture OR a
 * video (docs/briefs/playground-components.md §1). Serves the media-kind
 * stories. Rendered identically by the CMS canvas and the public site; only
 * media resolution differs, via BlockRenderProvider.
 */
const CONTAINER = "mx-auto max-w-7xl px-4 @min-[640px]:px-6 @min-[1024px]:px-8";
export function PlaygroundVideoBlock({ data }) {
    const { heading, subheading, media } = data;
    return (_jsx(Section, { children: _jsxs("div", { className: CONTAINER, children: [_jsx("h2", { className: "text-2xl font-bold text-foreground", children: heading }), subheading && (_jsx("p", { className: "mt-2 text-muted-foreground", children: subheading })), _jsx("div", { className: "mt-4", children: _jsx(MediaSlotView, { image: media, ratio: "16 / 9", label: "Media", emptyRender: null }) })] }) }));
}
export function playgroundVideoFromBlock(block, resolve) {
    const s = block.scalars ?? {};
    return {
        heading: s.heading ?? "",
        subheading: s.subheading || undefined,
        media: resolveSlotMedia(block, "media", resolve),
    };
}
export const playgroundVideoBlockEntry = {
    Component: PlaygroundVideoBlock,
    fromBlock: playgroundVideoFromBlock,
};
//# sourceMappingURL=playground-video.js.map